import React from "react";
import AOS from 'aos';
import "aos/dist/aos.css";
// import img
import Skills from "./Skills";

import { cards } from '../data';



const About = () => {
  AOS.init();
  return (
    <section className='section bg-primary' id='skills'>
      <div className='container mx-auto'>
        <div className='flex flex-col xl:flex-row'>
          {cards.map((card) => {
          const { icon } = card;
            return (
              <div className='lg:w-[699px] justify-center md:mx-auto lg:mx-auto' data-aos='zoom-in'>
              {icon}
              </div>
            );
          })}
          <div className='flex flex-col items-center text-center lg:items-start lg:text-left' data-aos='zoom-out'>
            <div className='flex flex-col font-tertiary'>
              <h2 className='text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3 before:content-stack relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block'>
                Stack
              </h2>
          </div>
          <Skills />
        </div>
      </div>
      </div>
    </section>
  );
};

export default About;
